import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { DataTable, ProgressBarWithColors } from "../../../components";
import { docsPendientesProv, formatoFechasEs } from "../../../functions/funciones";
import Add from "../../../icons/add.svg";
import {
  Box,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { cambiarProveedor, deleteProveedor, getProveedores } from "../../../services";
import {LoginAsSupp} from "../../../services/auth.service"
import { daysDiff } from "../../../functions/funciones";
import CircularProgress from "@mui/material/CircularProgress";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import FiltrosProveedores from "../../../components/filtros/filtrosProveedores";
import ExportarProveedoresLista from "./ExportarProveedoresLista";
import { UsuarioContext } from "../../../providers/userContext";
import Warning from "../../../icons/warning.svg";
import Delete from "../../../icons/delete.svg";
import { FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import Swal from "sweetalert2";
import { set } from "date-fns";
// import { FaEye } from "react-icons/fa";
import { Login } from '@mui/icons-material';


const ProveedoresLista = () => {
  const { t } = useTranslation(['suppliers', 'common']);

  const user = useContext(UsuarioContext)
  const [proveedores, setProveedores] = useState([]);
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [clean, setClean] = useState(false);
  const [estados, setEstados] = useState([]);

  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const [searchParams] = useSearchParams()
  const source = searchParams.get('source');
  
  const [primeraCarga, setPrimeraCarga] = useState(true);

  const refControladorAborto = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  let params = new URLSearchParams(location.search);
  const pagina = parseInt(params.get("pagina")) || 1;
  const limiteParam = parseInt(params.get("limite")) || 50;

  const clearFilters = () => {
    if (user.rol === "CONSUL" && localStorage.getItem("hasReloaded") === "true") {
      setBusqueda({
        consul_id: user.id 
      });
    }
    else if(user.rol === "CONSUL"){
      setBusqueda({
        consul_id: user.id 
      });
    }
    else{
      setBusqueda({});
    }
    
    setClearFilterActivo(true);
  }

  // useEffect(() => {
  //   fetchData();
  // },[recargar])

  const fetchData = async ({ offset, limit, filtros = busqueda, order,orderBy } = {}) => {
    const estadosCache = JSON.parse(localStorage.getItem("statesSupps")) || [];
    setEstados(estadosCache);
    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order = order || filtroOrder.orden || 'ASC';
    if (primeraCarga) {
      if (filtros.consul_id === undefined && user.rol === 'CONSUL') {
        filtros.consul_id = user.id
      } else if (filtros.consul_id === "0") {
        delete filtros.consul_id
      }
      setPrimeraCarga(false);
    }
    if(filtros.source && source!== undefined && source!==  null && source!== ""){
      const aaff_source = searchParams.get('aaff_source');
      filtros.source = 'taaf';
      filtros.aaff_source = aaff_source;
    }
    if(!filtros.source){
      delete filtros.source
      delete filtros.aaff_source
    }
    // if ( user.rol ==='CONSUL') {

    // } else if (user.rol ==='ADMIN') {
    //     delete filtros.consul_id
    // }


    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy);

    const payload = {
      filtros,
      params: { page: offset, limit, order, orderBy },
      signal: nuevoControladorAborto.signal
    };
    setLoading(true);
    try {
      const response = await getProveedores(payload);
      // Petición cancelada/superada por otra más reciente: no pisar los datos.
      if (!response) {
        return;
      }
      const { meta, data } = response;
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        if (refControladorAborto.current === nuevoControladorAborto) {
          setLoading(false);
        }
        return;
      }
      console.log(error);
    } finally {
      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };

  const formatData = (data) => {
    return data.map((row) => ({

      razonSocial: row.razonSocial,
      ultimaReclamacion: row.ultimaReclamacion === null ? row.createdAt : row.ultimaReclamacion,
      nif: row.nif,
      telefonoContacto: row.telefonoContacto,
      emailContacto: row.emailContacto,
      direccion:row.direccion,
      municipio: row.municipio,
      provincia: row.provincia,
      trabajadores: row.noProcede === null ? false : row.noProcede,
      estado: row.estado_id,
      cumplimiento: row.porcentajeDocs,
      docsPendientes: row.hasPendingDocs,
      // nuevosSuppsTaaf: row.newSuppsLastWeekTaaf,
      affTaaf:row.source,
      eliminarProv: <img src={Delete} onClick={() => handleEliminarProv(row.nif)} width={15} alt="eliminar" />,
    }));
  };

  const handleChangeTrabajadores = (evt, nif) => {
    const actualizarEstado = data.rows.map((row) => {
      if (row.nif === nif) {
        cambiarProveedor(nif, {
          noProcede: evt.target.value
        })
        return { ...row, trabajadores: evt.target.value === 'true' };

      }
      return row;
    });
    setData({ ...data, rows: actualizarEstado });
  };

  const handleChangeStateSupp = (evt, nif) => {
    const valor = parseInt(evt.target.value);
    const actualizarEstado = data.rows.map((row) => {
      if (row.nif === nif) {
        cambiarProveedor(nif, {
          estado_id: valor
        })
        return { ...row, estado: valor };
      }
      return row;
    });
    setData({ ...data, rows: actualizarEstado });
  };

  const proveedoresRows = [

    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.supplier'),
      overrideFunc: (data, row) =>
      (
        <Link to={"/proveedores/" + row.nif}>
          {data}
        </Link>
      )
    },
    {
      id: "ultimaReclamacion",
      numeric: false,
      disablePadding: false,
      label: t('columns.lastReclamation'),
      overrideFunc: (data) => data ? formatoFechasEs(data) : '',
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('common:form.nif'),
    },
    {
      id: "telefonoContacto",
      numeric: false,
      disablePadding: false,
      label: t('common:form.phone').toUpperCase(),
    },
    {
      id: "emailContacto",
      numeric: false,
      disablePadding: false,
      label: t('common:form.email').toUpperCase(),
    },
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('common:form.address').toUpperCase(),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('fields.municipality').toUpperCase(),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('fields.province').toUpperCase(),
    },
    {
      id: "cumplimiento",
      numeric: false,
      disablePadding: false,
      label: t('columns.compliance'),
      noObjeto:true,
      overrideFunc: (row) => (
        <ProgressBarWithColors
          value={row}
          label={
            <Typography>
              {row}
            </Typography>
          }
        />
      ),
    },
    {
      id: "trabajadores",
      numeric: false,
      disablePadding: false,
      label: t('editModal.fields.workers').toUpperCase(),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <div className="trabajadoresSelect">
          <Select
            label={t('editModal.fields.workers')}
            native
            name="trabajadores"
            id="trabajadores"
            style={{ width: 'auto !important', textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data ? "red" : 'green' }}
            onChange={(event) => handleChangeTrabajadores(event, row.nif)} value={data}
          >
            <option value={false}>{t('common:status.yes')}</option>
            <option value={true}>{t('common:status.no')}</option>
          </Select>
        </div>
      ),
    },
    {
      id: "estado",
      numeric: false,
      disablePadding: false,
      label: t('editModal.fields.state').toUpperCase(),
      noObjeto:true,
      overrideFunc: (data, row) => (  
        <div className="trabajadoresSelect">
          <Select
            label={t('editModal.fields.state')}
            native
            name="estado"
            id="estado"
            style={{ width: 'auto', minWidth: 80, maxWidth: 100, textTransform: 'uppercase', padding: 0, fontSize: '11px', color: data === 1 ||  data === null ? "#3eae3e" : data === 2 || data === 3 ? '#EE4534' : data === 4 || data === 5 ? "#FF8300" : "#000" }}
            onChange={(event) => handleChangeStateSupp(event, row.nif)} defaultValue={data}
          >
            {estados?.map((e, i) => {
              return (
                <option key={i} value={e.id} style={{ color: e.id === 1 || e.id == null ? "#3eae3e"  : e.id === 2 || e.id === 3 ? '#EE4534' : e.id === 4 || e.id === 5 ? "#FF8300" : "#000" }}>
                  {t(`common:stateNamesSupps.${e.nombre}`, e.nombre)}
                </option>
              );
            })}
          </Select>
        </div>
    )},
    {
      id: "docsPendientes",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto:true,
      overrideFunc: (row) => (
        <>
          {row === true ?
            <img src={Warning} width={15} alt="pendientes" />
            : null}
        </>
      ),
    },
    // {
    //   id: "nuevosSuppsTaaf",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "SINC",
    //   noObjeto: true,
    //   overrideFunc: (data, row) => (
    //     <div style={{ display: 'flex' }}>
    //       {row.nuevosSuppsTaaf > 0 ?
    //         <Tooltip title={`Proveedor nuevo de taaf en la última semana`} arrow>
    //           <div>
    //             <FaEye style={{ fontSize: '2rem' }} />
    //           </div>
    //         </Tooltip>
    //       : null
    //       }
    //     </div>
    //   ),
    // },
    {
      id: "affTaaf",
      numeric: false,
      disablePadding: false,
      label: t('columns.source'), // Header
      noObjeto: true, // ORDER BY
      overrideFunc: (data, row) => (
        <div style={{ display: 'flex' }}>
        {row.affTaaf}
        </div>
      ),
    },
    {
      id: "eliminarProv",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto:true,
    },
    user.rol === 'ADMIN' || user.rol === 'CONSUL' ?
    {
      id: "login",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Tooltip title={t('common:messages.loginAs', { name: row.razonSocial })} >
          <div className="bigBtn p-2" onClick={() => {LoginAsSupp(row.nif)}}>
            <Login fontSize="small" />
          </div>
        </Tooltip>
      )
    }
    :
    {

      noObjeto:true

    },
  ]

  const handleCallback = () => {
    setRecargar(!recargar);
  };

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros)
    setBusquedaActiva(true);
  }

  const handleEliminarProv = async (nif) => {
    eliminarProv(nif).then((resultado) => {
      handleCallback(resultado)
    })
  }

  const eliminarProv = async (nif) => {
        return new Promise(async (resolve, reject) => {
      try {
        const result = await Swal.fire({
          title: t('confirmations.deleteSupplier'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#888",
          cancelButtonText: t('common:actions.cancel'),
          confirmButtonText: t('common:actions.delete')
        });

        if (result.isConfirmed) {
          const toastInfo = toast.info(t('confirmations.deletingSupplier'), { autoClose: false });
          await deleteProveedor(nif).then(res => {

            if (res.message === "SUPPLIER_DELETED") {
              toast.update(toastInfo, {
                render: t('common:messages.deletedSuccessfully'),
                type: toast.TYPE.SUCCESS,
                autoClose: true
              });
              resolve(true);
              // navigate("/proveedores");
              // clearFilters();
              // setClean(!clean);
              fetchData({ offset: 1, limit: limiteParam, filtros:busqueda});
            }else {
              toast.update(toastInfo, {
                render: t('confirmations.deleteError'),
                type: toast.TYPE.ERROR,
                autoClose: true
              });
            }
          }).catch(error => {
            console.log(error);
            toast.update(toastInfo, {
              render: t('confirmations.deleteError'),
              type: toast.TYPE.ERROR,
              autoClose: true
            });
            reject(error);
          })
        }

      } catch (error) {
        console.error("Error al eliminar el proveedor:", error);
        reject(error);
      }
    })
  }

  useEffect(() => {
      return () => {
        if (refControladorAborto.current) {
          refControladorAborto.current.abort();
        }
      };
    }, []);

  return (
    <>
      <BreadCrumb rutas={[{ path: `/proveedores`, label: t('title') }]} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('list').toUpperCase()}</div>
          <div className="tableContainer">
            <div className="contentBar">
              <div className="contentBtns">
              </div>
              <Link to="/proveedores/nuevo" target={"_blank"}>
                <div className="contentButton">
                  <img src={Add} alt={t('common:actions.more')} />
                </div>
              </Link>
            </div>
            <div style={{ display: "flex" }}>
              <FiltrosProveedores onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} clean = {clean} />
            </div>
            <div style={{ display: "flex", margin: "20px 0" }}>
              <ExportarProveedoresLista busqueda={busqueda} filtroOrder={filtroOrder} />
            </div>
            <div className="tableWrapper">
              <Box className="pageContent">
                <Box sx={{ mb: 10 }}>
                  <DataTable
                    data={data.rows}
                    isLoading={loading}
                    headers={proveedoresRows}
                    fetcher={fetchData}
                    currentPage={data.current_page}
                    meta={data.meta}
                    totalItems={data.total}
                    totalPages={data.totalPages}
                    nextPage={data.next_page}
                    filtros={busqueda}
                    busquedaActiva={busquedaActiva}
                    setBusquedaActiva={setBusquedaActiva}
                    clearFilterActivo={clearFilterActivo}
                    setClearFilterActivo={setClearFilterActivo}
                    mensaje={t('noSuppliers')}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <style jsx="true">{`
          #trabajadores, #estado{
            padding:0 25px 0 0;
            border: none;
          }
          .trabajadoresSelect fieldset, .trabajadoresSelect select:hover{
            border-color: rgba(0, 0, 0, 0) !important;
          }               
      `}</style>
    </>
  );
};

export default withRouter(ProveedoresLista);
